import React, { useEffect, useState } from 'react';
import appLogo from '../../assets/images/header-logo.png';
import menuOpenImg from '../../assets/images/menu-open.svg';
import menuCloseImg from '../../assets/images/menu-cross.png';
import Viber from '../../assets/images/viber.svg';
import Insta from '../../assets/images/Insta.svg';
import Whatsapp from '../../assets/images/whatsapp.svg';
import FaceBook from '../../assets/images/Facebook.svg';
import VK from '../../assets/images/vk.svg';
import Max from '../../assets/images/max.svg';
import ModalMenu from "../ModalMenu/ModalMenu";
import AnchorLink from "react-anchor-link-smooth-scroll";
import './Header.styles.scss';
import { Logo } from '../../shared/logo/Logo';
import { useDevice } from '../../hooks/use-device/useDevice';
import { Burger } from '../../shared/burger/Burger';

export const HeaderCompanies = () => {
    const [isMenuActive, setMenuActive] = useState(false);
    const { isDesktop } = useDevice();
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        if (isMenuActive) {
            document.documentElement.style.overflow = 'hidden'; // Disable scrolling
        } else {
            document.documentElement.style.overflow = 'auto'; // Enable scrolling
        }

        // Clean up function to reset the overflow style
        return () => {
            document.documentElement.style.overflow = 'auto';
        };
    }, [isMenuActive]);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > window.innerHeight) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const headerClass = `header ${isMenuActive ? 'back-color' : ''} ${isScrolled ? 'scrolled-bg' : 'back-color-none'}`;

    const handleBurgerClick = () => {
        setMenuActive(!isMenuActive);
    };

    return (
        <section className='header-section'>
            <header className={headerClass.trim()}>
                <div className='container'>
                    <div className='header-wrapper'>
                        <Logo variant="default" />
                        {/* <img className='burger-menu' onClick={() => setIsMenuOpen(!isMenuOpen)} src={isMenuOpen ? menuCloseImg : menuOpenImg}
                            alt="burger" /> */}
                        {!isDesktop &&
                            <Burger isActive={isMenuActive} onClick={handleBurgerClick} />
                        }
                        <div className='header-menu-wrapper'>
                            <ul className='header-menu-list'>
                                <li className='header-menu-item'><a href="/" className='anchor-link'>Для частных лиц</a></li>
                                <li className='header-menu-item'><AnchorLink href="#kontakt" className='anchor-link'>Контакты</AnchorLink></li>
                                <li className='header-menu-item'><a href="https://alpairya.ru" target='__blank' className='anchor-link orange'>Разработка ПО и Приложений</a></li>
                            </ul>
                        </div>
                        <ul className='social-list'>
                            <li className="social-list__item">
                                <a href='https://vk.com/belo_klining' target='__blank' className="social-list__link">
                                    <img src={VK} alt="ВКонтакте" />
                                </a>
                            </li>
                            <li className="social-list__item">
                                <a href='https://max.ru/belo_klining' target='__blank' className="social-list__link">
                                    <img src={Max} alt="МАКС" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
            {isMenuActive && <ModalMenu closeMenu={() => setMenuActive(false)} />}
            <div className='hero'>
                <div className='container'>
                    <div className='hero__container'>
                        <h2>Услуги профессиональной уборки</h2>
                        <span>Убираем объекты любой площади</span>
                        <button className="button" type="button">
                            <AnchorLink href="#skontaktuj">Свяжитесь с нами</AnchorLink>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};